import {useParams} from "react-router-dom";
import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminTaxInvoiceInfo from "../../../components/admin/billing/AdminTaxInvoiceInfo";
//어드민 결제 내역 상세 페이지
const AdminTaxInvoiceInfoPage: React.FC = () => {
    const {id} = useParams<{ id: string }>();

    //결제 식별자가 없는 경우
    if (!id) {
        return <div>Invalid payment ID</div>;
    }

    return (
        <AdminLayout>
            {/*결제 상세 정보*/}
            <AdminTaxInvoiceInfo taxInvoiceId={parseInt(id)}/>
        </AdminLayout>
    )
}

export default AdminTaxInvoiceInfoPage;